import { useTranslation } from 'react-i18next';
import { motion } from 'motion/react';
import { Plus } from 'lucide-react';
import { FormModal } from '@/components/modal/FormModal';
import { haptic } from '@/utils/haptics';
import type { DockApp } from './dockRegistry';

interface AppStoreDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  apps: DockApp[];
  onAdd: (id: string) => void;
}

export function AppStoreDrawer({ isOpen, onClose, apps, onAdd }: AppStoreDrawerProps) {
  const { t } = useTranslation();

  const handleAdd = (id: string) => {
    haptic.light();
    onAdd(id);
    if (apps.length <= 1) onClose();
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={t('home.dock.addShortcut')}
    >
      <div className="grid grid-cols-3 gap-3">
        {apps.map((app) => {
          const Icon = app.icon;
          return (
            <motion.button
              key={app.id}
              className="flex flex-col items-center gap-2 rounded-2xl bg-white/50 p-3 backdrop-blur-sm transition-colors hover:bg-white/70"
              whileTap={{ scale: 0.95 }}
              onClick={() => handleAdd(app.id)}
            >
              <div
                className="flex h-12 w-12 items-center justify-center rounded-full"
                style={{ backgroundColor: `${app.color}15` }}
              >
                <Icon size={22} style={{ color: app.color }} strokeWidth={1.8} />
              </div>
              <span className="text-xs font-medium text-gray-700">
                {t(app.labelKey)}
              </span>
              <span className="flex items-center gap-0.5 text-[10px] font-medium text-primary-600">
                <Plus size={10} />
                {t('home.dock.add')}
              </span>
            </motion.button>
          );
        })}
      </div>
    </FormModal>
  );
}
